<template>
  <div class="passenger-transactions">
    <br />
    <h1 style="text-align: center;">Passenger Transactions</h1>
    <div class="layout justify-end pr-3 pl-3">
      <v-btn v-if="isAdmin && !isOnlyInvestor" @click="openTransferTicketDialog" small>
        <v-icon small left>fal fa-exchange</v-icon>
        Transfer Ticket
      </v-btn>
      <v-btn v-if="isAdmin && !isOnlyInvestor" @click="openUnusedBalanceRefundDialog" small>
        <v-icon small left>fal fa-recycle</v-icon>
        Create Ticket Refund
      </v-btn>
      <v-btn v-if="isAdmin && !isOnlyInvestor" @click="createAgentCreditRefundDialog = true" small>
        <v-icon small left>fal fa-undo</v-icon>
        Refund Agent Credit
      </v-btn>
    </div>
    <form @submit.prevent="submitSearch">
      <v-layout row wrap>
<!--        <v-flex v-show="selectedVendor !== 'mtnghana'" sm3 pa-2>-->
<!--          <v-text-field-->
<!--              solo-->
<!--              v-model="searchKeywords"-->
<!--              append-icon="fal fa-search"-->
<!--              :rules="[v => !v || v.length >= 2 || 'Min 2 characters']"-->
<!--              :disabled="apiInProgress"-->
<!--              type="search"-->
<!--              placeholder="Search by email or name"-->
<!--              @keyup.enter="searchTransactions"-->
<!--              @click:append="searchTransactions"-->
<!--          />-->
<!--        </v-flex>-->
        <v-flex sm4 pa-2>
          <v-text-field
              solo
              clearable
              v-model="searchPhone"
              append-icon="fal fa-search"
              :rules="[v => !v || (/[\s\d-()+]+/.test(v) && v.length >= 2) || 'Please provide only numbers or \'+\' (min 2 digits)']"
              :disabled="apiInProgress"
              type="search"
              placeholder="Search by phone"
              @keyup.enter="submitSearch"
              @click:append="submitSearch"
          />
        </v-flex>
        <v-flex sm3 pa-2>
          <v-select
            :items="logTypes"
            clearable
            label="Log Type"
            dense
            multiple
            single-line
            placeholder="Select Log Type(s)"
            v-model="selectedLogTypes"
          >
            <template v-slot:selection="{ item, index }">
              <small v-if="index === 0">{{ item.text }}</small>
              <small v-if="index === 1"
                class="grey--text caption pl-2"
              >(+{{ selectedLogTypes.length - 1 }} others)</small>
            </template>
          </v-select>
        </v-flex>
        <v-flex sm4>
          <v-layout>
            <v-flex xs6 pa-2>
              <st-date-field
                id="passenger-transactions-date-from"
                v-model="dateFrom"
                label="Date From"
                to-date-id="passenger-transactions-date-to"
              />
            </v-flex>
            <v-flex xs6 pa-2>
              <st-date-field
                id="passenger-transactions-date-to"
                v-model="dateTo"
                label="Date To"
                from-date-id="passenger-transactions-date-from"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- <v-flex sm2 pa-2>
          <v-select
              :items="vendors"
              :clearable="!isVendor"
              label="Vendor"
              v-model="selectedVendor"
          />
        </v-flex> -->
        <v-flex sm1 pa-2>
          <v-btn small fab type="submit"><v-icon small>fal fa-filter</v-icon></v-btn>
        </v-flex>
      </v-layout>
    </form>
    <v-data-table
        :headers="headers"
        :items="transactions"
        :pagination.sync="pagination"
        :total-items="tableTotalItems"
        :hide-actions="!isTotalTransactionsKnown"
        :loading="apiInProgress"
        :rows-per-page-items="[10, 25, 50]"
        @update:pagination="onPagination"
        class="elevation-1 passenger-transactions-table"
        must-sort
    >
      <template v-slot:items="props">
        <tr @click="viewMetadata(props.item)">
          <td v-if="isAdmin && !isOnlyInvestor" @click.stop="props.item.selected = !props.item.selected" class="layout justify-center align-center passenger-transaction-checkbox-cell">
            <v-checkbox
              v-if="props.item.logType === 'purchased_ticket' && !Boolean(props.item.logMetadata && props.item.logMetadata.unusedBalanceRefundId)"
              v-model="props.item.selected"
              @change="props.item.selected = !props.item.selected"
              class="ma-0 pa-0"
              hide-details
            />
            <v-tooltip
              top
              v-if="props.item.logType === 'purchased_ticket' && Boolean(props.item.logMetadata && props.item.logMetadata.unusedBalanceRefundId)"
            >
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">fas fa-info-circle</v-icon>
              </template>
              <span>
                This transaction is associated with ticket refund {{props.item.logMetadata.unusedBalanceRefundId}}
              </span>
            </v-tooltip>
          </td>
          <td :title="props.item.phoneLabel" class="passenger-transaction-phone-cell">
            {{props.item.phoneLabel}}
          </td>
          <!-- <td class="text-xs-right" :title="props.item.stUser && props.item.stUser.email">
            <v-text-field
              class="text-xs-right text-field--flat"
              :value="props.item.stUser ? props.item.stUser.email : ''"
              readonly
              hide-details
            />
          </td> -->
          <td>
            <div v-html="props.item.amountLabel" />
            <div v-if="props.item.logMetadata.isReservedTicket">
              <v-chip small>
                <small>Flat Rate Fare</small>
              </v-chip>
            </div>
          </td>
          <td v-html="props.item.profileBalanceBeforeLabel" />
          <td v-html="props.item.profileBalanceAfterLabel" />
          <td :title="props.item.logTypeLabel" class="passenger-transaction-type-cell">
            <div class="passenger-transaction-type-cell__content">
              <v-icon v-if="props.item.logTypeIcon" small class="passenger-transaction-type-cell__icon">{{props.item.logTypeIcon}}</v-icon>
              <v-text-field
                class="text-xs-left text-field--flat pb1"
                :value="props.item.logTypeLabel"
                readonly
                hide-details
                @click.stop
              />
            </div>
            <div v-if="props.item.isAgentTopUp">
              <v-chip small class="passenger-transaction-type-chip mb-1">
                <small>agent top up</small>
              </v-chip>
            </div>
            <div v-if="props.item.logType === 'penalty_topup' || props.item.logType === 'penalty_topup_reversal'">
              <v-chip small class="passenger-transaction-type-chip mb-1">
                <small>penalty top-up</small>
              </v-chip>
            </div>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">{{props.item.logStatusIcon}}</v-icon>
              </template>
              <span v-html="props.item.logStatusTooltip" />
            </v-tooltip>
          </td>
          <td class="passenger-transaction-date-cell">
            <small v-html="props.item.dateUpdatedLabel" />
          </td>
          <td class="passenger-transaction-date-cell">
            <small v-html="props.item.dateRecordedLabel" />
            <div v-if="props.item.showDateCreatedInTag">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-chip small class="passenger-transaction-date-chip" v-on="on">
                    <v-icon small left v-if="props.item.logMetadata && props.item.logMetadata.transportationProfileEventId">fas fa-calendar-star</v-icon>
                    <v-icon small left v-else>fal fa-clock</v-icon>
                    <small>{{props.item.dateCreatedLabel}}</small>
                  </v-chip>
                </template>
                <span>{{props.item.logMetadata && props.item.logMetadata.transportationProfileEventId ? 'Event' : 'Reserved'}}</span>
              </v-tooltip>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div v-if="!isTotalTransactionsKnown" class="layout row justify-space-between align-center pa-3">
      <div class="layout row justify-end align-center" style="width: 100%;">
        <small class="pr-2">Page {{ Number(pagination.page) }}</small>
        <v-btn icon :disabled="!canGoToPreviousPage" @click="goToPreviousPage">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn icon :disabled="!canGoToNextPage" @click="goToNextPage">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </div>
    </div>
    <st-dialog
      v-model="createAgentCreditRefundDialog"
      transition="dialog-bottom-transition"
      scrollable
      persistent
      max-width="600"
      label="Refund Agent Credit Back to Agent"
    >
      <template v-if="createAgentCreditRefundDialog">
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Agent</strong>
            </v-flex>
            <v-flex sm8 pt-2 pl-2 pr-2>
              <agent-selector
                v-model="newAgentCreditRefund.agent"
                :child-props="{ placeholder: 'Search by phone number, name or email', label: 'Selected agent', outline: true }"
              />
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Passenger</strong>
            </v-flex>
            <v-flex sm8 pt-2 pl-2 pr-2>
              <passenger-selector
                v-model="newAgentCreditRefund.passengerIdentifier"
                :child-props="{ placeholder: 'Search by phone number or name', label: 'Selected passenger', outline: true }"
              />
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Amount</strong>
            </v-flex>
            <v-flex sm8 pa-2>
              <currency-field
                v-model="newAgentCreditRefund.amount"
                :child-props="{
                  prefix: countryCurrency ? countryCurrency.currencySymbol : '',
                  placeholder: '0.00'
                }"
              />
            </v-flex>
          </v-layout>
          <v-alert v-if="selectedAgentBlocksAdminRefund" :value="true" type="warning" class="mt-3">
            Agent credit refunds are not available for this agent. The passenger can refund unused credit to their own mobile money account.
          </v-alert>
      </template>
      <template v-slot:footer>
        <v-btn class="warning" flat @click="createAgentCreditRefundDialog = false">
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          class="primary"
          :disabled="selectedAgentBlocksAdminRefund || !newAgentCreditRefund.agent || !newAgentCreditRefund.amount || !newAgentCreditRefund.passengerIdentifier"
          :loading="apiInProgress"
          @click="saveAgentCreditRefund({
            newAgentCreditRefund
          })"
        >
          Save
        </v-btn>
      </template>
    </st-dialog>
    <st-dialog
      v-model="createUnusedBalanceRefundDialog"
      transition="dialog-bottom-transition"
      scrollable
      persistent
      max-width="600"
      label="Create Ticket Refund"
    >
      <template v-if="createUnusedBalanceRefundDialog">
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Passenger</strong>
            </v-flex>
            <v-flex sm8 pa-2>
              {{ refundPassengerPhoneLabel || 'Unknown phone number' }}
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Amount</strong>
            </v-flex>
            <v-flex sm8 pa-2>
              <currency-field
                v-model="newUnusedBalanceRefund.amount"
                :child-props="{
                  prefix: countryCurrency ? countryCurrency.currencySymbol : '',
                  placeholder: '0.00',
                  hint: refundSurchargeHint,
                  persistentHint: !!refundSurchargeHint
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row align-top>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Selected Purchased Ticket(s)</strong>
            </v-flex>
            <v-flex sm8 pa-2>
              <div v-if="!selectedPurchasedTickets.length">
                No ticket(s) selected to associate with refund
              </div>
              <div v-else>
                <div class="mb-2">
                  <strong>Total: </strong>
                  <span v-html="selectedPurchasedTicketsTotalLabel" />
                </div>
                <div style="max-height: 100px; overflow-y: auto; padding-right: 10px">
                  <div
                    v-for="purchasedTicket in selectedPurchasedTickets"
                    :key="purchasedTicket.id"
                  >
                    <div class="refund-ticket">
                      <div class="refund-ticket__id">
                        <strong>{{purchasedTicket.parsedId}}</strong>
                      </div>
                      <div v-if="!ticketFareFeeLabel(purchasedTicket)" class="refund-ticket__amount" v-html="purchasedTicket.amountLabel" />
                      <div class="refund-ticket__date" v-html="purchasedTicket.dateCreatedLabel" />
                      <div v-if="ticketFareFeeLabel(purchasedTicket)" class="refund-ticket__fee caption grey--text">
                        {{ ticketFareFeeLabel(purchasedTicket) }}
                      </div>
                    </div>
                    <div style="border-bottom: 1px solid #ccc"></div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
      </template>
      <template v-slot:footer>
        <v-btn class="warning" flat @click="createUnusedBalanceRefundDialog = false">
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          class="primary"
          :disabled="!selectedPurchasedTickets.length || !newUnusedBalanceRefund.passengerProfileId || !newUnusedBalanceRefund.amount"
          :loading="apiInProgress"
          @click="saveUnusedBalanceRefund({
            newUnusedBalanceRefund,
            selectedPurchasedTickets
          })"
        >
          Save
        </v-btn>
      </template>
    </st-dialog>
    <st-dialog
      v-model="transferTicketDialog"
      transition="dialog-bottom-transition"
      scrollable
      persistent
      max-width="720"
      label="Transfer Ticket"
    >
      <template v-if="transferTicketDialog">
          <template v-if="transferTicket.mode === 'single' && transferTicket.ticket">
            <v-layout row align-center>
              <v-flex sm4 pa-2 class="text-xs-right">
                <strong>Ticket</strong>
              </v-flex>
              <v-flex sm8 pa-2>
                {{ transferTicket.ticket.parsedId }}
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm4 pa-2 class="text-xs-right">
                <strong>Passenger</strong>
              </v-flex>
              <v-flex sm8 pa-2>
                {{ transferTicket.ticket.phoneLabel || 'Unknown phone number' }}
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm4 pa-2 class="text-xs-right">
                <strong>Price</strong>
              </v-flex>
              <v-flex sm8 pa-2>
                <span v-html="transferTicket.ticket.amountLabel" />
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm4 pa-2 class="text-xs-right">
                <strong>Date created</strong>
              </v-flex>
              <v-flex sm8 pa-2>
                <span v-html="transferTicket.ticket.dateCreatedLabel" />
              </v-flex>
            </v-layout>
          </template>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>From transportation</strong>
            </v-flex>
            <v-flex sm8 pt-2 pl-2 pr-2>
              <transportation-profile-autocomplete
                :value="transferTicket.fromProfile"
                label="From transportation"
                :disabled="transferTicketTripsLoading"
                :exclude-profile-id="transferTicket.toProfile && transferTicket.toProfile.id"
                @input="setTransferFromProfile"
              />
              <div v-if="transferTicketTripsLoading" class="caption grey--text">
                Loading the ticket vehicle...
              </div>
              <div v-else-if="transferTicket.mixedPlates.length" class="caption">
                This ticket is on more than one vehicle ({{ transferTicket.mixedPlates.join(', ') }}). Choose which one to move.
              </div>
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>To transportation</strong>
            </v-flex>
            <v-flex sm8 pt-2 pl-2 pr-2>
              <transportation-profile-autocomplete
                :value="transferTicket.toProfile"
                label="To transportation"
                :exclude-profile-id="transferTicket.fromProfile && transferTicket.fromProfile.id"
                @input="setTransferToProfile"
              />
            </v-flex>
          </v-layout>
          <template v-if="transferTicket.mode === 'bulk'">
            <v-layout row align-center>
              <v-flex sm4 pa-2 class="text-xs-right">
                <strong>Date from</strong>
              </v-flex>
              <v-flex sm8 pa-2>
                <st-date-field
                  id="transfer-ticket-date-from"
                  v-model="transferTicket.dateFrom"
                  label="Date from"
                  with-time
                  return-date
                  :min="transferDateBounds.fromMin"
                  :max="transferDateBounds.fromMax"
                />
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm4 pa-2 class="text-xs-right">
                <strong>Date to</strong>
              </v-flex>
              <v-flex sm8 pa-2>
                <st-date-field
                  id="transfer-ticket-date-to"
                  v-model="transferTicket.dateTo"
                  label="Date to"
                  with-time
                  return-date
                  :min="transferDateBounds.toMin"
                  :max="transferDateBounds.toMax"
                />
                <div class="caption grey--text">
                  Start and end must be on the same day. The end time is not included.
                </div>
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm4 pa-2 class="text-xs-right">
                <strong>Agent</strong>
              </v-flex>
              <v-flex sm8 pt-2 pl-2 pr-2>
                <agent-selector
                  v-model="transferTicket.agent"
                  :child-props="{ placeholder: 'Search by phone number, name or email', label: 'Selected agent', outline: true }"
                />
              </v-flex>
            </v-layout>
          </template>
      </template>
      <template v-slot:footer>
        <v-btn class="warning" flat @click="transferTicketDialog = false">
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          class="primary"
          :disabled="transferSaveDisabled"
          :loading="apiInProgress"
          @click="saveTransferTicket"
        >
          Save
        </v-btn>
      </template>
    </st-dialog>
    <st-dialog
      ref="metadataDialog"
      v-model="metadataLoaded"
      transition="dialog-bottom-transition"
      scrollable
      max-width="920"
      show-close
    >
      <template v-slot:header>
        <span v-if="selectedMetadata">{{ selectedMetadata.phoneLabel }} Transaction details</span>
      </template>
      <template v-if="selectedMetadata">
          <v-tabs ref="metadataDialogTabs" v-if="isSelectedPurchasedTicket" v-model="metadataTab" grow>
            <v-tabs-slider color="primary" />
            <v-tab ripple href="#details">
              Ticket Details
            </v-tab>
            <v-tab ripple href="#trips">
              Trip(s)
            </v-tab>
          </v-tabs>
          <div
            v-show="!isSelectedPurchasedTicket || metadataTab === 'details'"
            class="txn-details pt-3"
            :class="{ 'txn-split': isAdmin }"
          >
            <div :class="{ 'txn-split__cards': isAdmin }">
              <div class="info-card">
                <div class="info-card__head">
                  <v-icon class="info-card__icon">far fa-receipt</v-icon>
                  <span class="info-card__label">Transaction</span>
                </div>
                <v-layout row wrap>
                  <v-flex sm4 pr-1 class="text-xs-right">
                    <strong>Amount</strong>
                  </v-flex>
                  <v-flex sm8 pl-1>
                    <div class="info-card__value" v-html="selectedMetadata.amountLabel" />
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-for="row in transactionInfoRows" :key="'txn-' + row.label">
                  <v-flex sm4 pr-1 class="text-xs-right">
                    <strong>{{ row.label }}</strong>
                  </v-flex>
                  <v-flex sm8 pl-1 class="layout row align-center">
                    <v-icon v-if="row.icon" small class="mr-1">{{ row.icon }}</v-icon>
                    <div>{{ row.value }}</div>
                  </v-flex>
                </v-layout>
              </div>

              <div class="info-card">
                <div class="info-card__head">
                  <v-icon class="info-card__icon">far fa-clock</v-icon>
                  <span class="info-card__label">Dates</span>
                </div>
                <v-layout row wrap v-for="row in dateInfoRows" :key="'date-' + row.label">
                  <v-flex sm4 pr-1 class="text-xs-right">
                    <strong>{{ row.label }}</strong>
                  </v-flex>
                  <v-flex sm8 pl-1>
                    <div>{{ row.value }}</div>
                  </v-flex>
                </v-layout>
              </div>

              <div class="info-card" v-if="eventDetailRows.length">
                <div class="info-card__head">
                  <v-icon class="info-card__icon">far fa-calendar-star</v-icon>
                  <span class="info-card__label">Event</span>
                </div>
                <v-layout row wrap v-for="row in eventDetailRows" :key="'event-' + row.label">
                  <v-flex sm4 pr-1 class="text-xs-right">
                    <strong>{{ row.label }}</strong>
                  </v-flex>
                  <v-flex sm8 pl-1>
                    <div>{{ row.value }}</div>
                  </v-flex>
                </v-layout>
              </div>

              <div class="info-card" v-if="hasPeopleDetails">
                <div class="info-card__head">
                  <v-icon class="info-card__icon">far fa-user</v-icon>
                  <span class="info-card__label">People</span>
                </div>
                <v-layout row wrap v-for="action in relatedUserActions" :key="'user-action-' + action.label">
                  <v-flex sm4 pr-1 class="text-xs-right">
                    <strong>{{ action.label }}</strong>
                  </v-flex>
                  <v-flex sm8 pl-1 class="layout row align-center">
                    <div class="mr-2">{{ action.stUserId }}</div>
                    <v-btn small @click="viewUser(action.stUserId)"><small>View User</small></v-btn>
                  </v-flex>
                </v-layout>
                <div v-if="viewedUserRows.length" class="info-card__sublabel">User details</div>
                <v-layout row wrap v-for="row in viewedUserRows" :key="'viewed-user-' + row.label">
                  <v-flex sm4 pr-1 class="text-xs-right">
                    <strong>{{ row.label }}</strong>
                  </v-flex>
                  <v-flex sm8 pl-1>
                    <div>{{ row.value }}</div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="selectedMetadata.isAgentTopUp">
                  <v-flex sm4 pr-1 class="text-xs-right">
                    <strong>Agent</strong>
                  </v-flex>
                  <v-flex sm8 pl-1>
                    <v-btn small @click="viewAgent()"><small>View Agent</small></v-btn>
                  </v-flex>
                </v-layout>
                <div v-if="viewedAgentRows.length" class="info-card__sublabel">Agent details</div>
                <v-layout row wrap v-for="row in viewedAgentRows" :key="'viewed-agent-' + row.label">
                  <v-flex sm4 pr-1 class="text-xs-right">
                    <strong>{{ row.label }}</strong>
                  </v-flex>
                  <v-flex sm8 pl-1>
                    <div>{{ row.value }}</div>
                  </v-flex>
                </v-layout>
              </div>
            </div>

            <div v-if="isAdmin" class="txn-split__aside">
              <div class="info-card">
                <div class="info-card__head">
                  <v-icon class="info-card__icon">far fa-code</v-icon>
                  <span class="info-card__label">Metadata</span>
                </div>
                <div v-if="hasLogMetadata" class="txn-json-viewer-wrap">
                  <json-viewer
                    :value="logMetadataValue"
                    :expand-depth="1"
                    boxed
                    copyable
                    sort
                    class="txn-json-viewer"
                  />
                </div>
                <div v-else class="info-card__placeholder">No metadata available</div>
              </div>
            </div>
          </div>
          <div v-if="isSelectedPurchasedTicket" v-show="metadataTab === 'trips'" class="txn-details pt-3">
            <v-alert v-if="transactionTripsError" :value="true" type="error">
              {{transactionTripsError}}
            </v-alert>
            <div v-else-if="transactionTripsLoading" class="text-xs-center pa-4">
              <v-progress-circular indeterminate color="primary" />
              <div class="mt-2">Loading linked trips...</div>
            </div>
            <v-alert v-else-if="!transactionTrips.length" :value="true" type="info">
              No trips are linked to this ticket.
            </v-alert>
            <div v-else-if="selectedTrip" class="txn-split">
              <div class="txn-split__cards">
                <div class="info-card" v-if="transactionTrips.length > 1">
                  <div class="info-card__head">
                    <v-icon class="info-card__icon">far fa-map</v-icon>
                    <span class="info-card__label">Trips</span>
                  </div>
                  <v-select
                    :items="selectedTripOptions"
                    v-model="selectedTripId"
                    label="Select trip"
                    outline
                    hide-details
                    class="mt-1"
                  />
                </div>
                <div class="info-card">
                  <div class="info-card__head">
                    <img
                      class="passenger-trip-endpoint-pin"
                      :src="tripBoardIconUrl"
                      alt=""
                      aria-hidden="true"
                    />
                    <span class="info-card__label">Board</span>
                  </div>
                  <v-layout row wrap>
                    <v-flex sm4 pr-1 class="text-xs-right">
                      <strong>Location</strong>
                    </v-flex>
                    <v-flex sm8 pl-1>
                      {{selectedTrip.originLabel || 'N/A'}}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex sm4 pr-1 class="text-xs-right">
                      <strong>Time</strong>
                    </v-flex>
                    <v-flex sm8 pl-1>
                      {{selectedTrip.dateEmbarkedLabel || 'N/A'}}
                    </v-flex>
                  </v-layout>
                </div>
                <div class="info-card">
                  <div class="info-card__head">
                    <img
                      class="passenger-trip-endpoint-pin"
                      :src="tripAlightIconUrl"
                      alt=""
                      aria-hidden="true"
                    />
                    <span class="info-card__label">Alight</span>
                  </div>
                  <v-layout row wrap>
                    <v-flex sm4 pr-1 class="text-xs-right">
                      <strong>Location</strong>
                    </v-flex>
                    <v-flex sm8 pl-1>
                      {{selectedTrip.destinationLabel || 'N/A'}}
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex sm4 pr-1 class="text-xs-right">
                      <strong>Time</strong>
                    </v-flex>
                    <v-flex sm8 pl-1>
                      {{selectedTrip.dateDisembarkedLabel || 'N/A'}}
                    </v-flex>
                  </v-layout>
                </div>
                <div class="info-card">
                  <div class="info-card__head">
                    <v-icon class="info-card__icon">far fa-road</v-icon>
                    <span class="info-card__label">Trip</span>
                  </div>
                  <v-layout row wrap v-for="row in selectedTripInfoRows" :key="'trip-' + row.label">
                    <v-flex sm4 pr-1 class="text-xs-right">
                      <strong>{{ row.label }}</strong>
                    </v-flex>
                    <v-flex sm8 pl-1>
                      {{ row.value }}
                    </v-flex>
                  </v-layout>
                </div>
                <v-alert v-if="tripBusStopsLoading" :value="true" type="info">
                  Loading route bus stops...
                </v-alert>
              </div>
              <div class="txn-split__aside txn-split__aside--map">
                <st-map
                  v-if="shouldRenderTripMap"
                  :key="tripMapContainerId + '-' + selectedTripId"
                  disable-search
                  disable-map-hash
                  :height-offset="tripMapHeightOffset"
                  :container-id="tripMapContainerId"
                  :api="stMapApis"
                  :mapbox-access-token="mapboxAccessToken"
                  :maptiler-key="maptilerKey"
                  :marker-options="markerOptions"
                  :default-center="tripMapDefaultCenter"
                  :default-zoom="12"
                  :route-coordinates="selectedTripRouteCoordinates"
                  :on-map-loaded="onTripMapLoaded"
                />
                <v-alert v-else :value="true" type="warning">
                  Map keys are not configured for this environment.
                </v-alert>
              </div>
            </div>
            <v-alert v-else :value="true" type="warning">
              Select a trip to view its map.
            </v-alert>
          </div>
      </template>
      <template v-slot:footer v-if="canExpireSelectedTicket || canRefundPurchasedBeacon">
        <v-checkbox
          v-if="canExpireSelectedTicket"
          class="txn-details-footer__checkbox mt-0 pt-0"
          :hide-details="!expireNowSurchargeHint"
          :hint="expireNowSurchargeHint"
          persistent-hint
          v-model="expireNowRefundUnusedBalance"
          label="Refund ticket balance"
          :disabled="apiInProgress"
        />
        <v-spacer />
        <v-btn
          v-if="canExpireSelectedTicket"
          class="warning"
          :loading="apiInProgress"
          :disabled="apiInProgress"
          @click="expireTicketNow()"
          small
        >
          Expire now
        </v-btn>
        <v-btn
          v-else-if="canRefundPurchasedBeacon"
          class="warning"
          :loading="apiInProgress"
          :disabled="apiInProgress"
          @click="confirmRefundPurchasedBeacon()"
          small
        >
          Refund purchased beacon
        </v-btn>
      </template>
    </st-dialog>
  </div>
</template>

<script>
import src from './src'
export default src
</script>

<style scoped>
.refund-ticket {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  column-gap: 12px;
  align-items: start;
  margin-bottom: 8px;
}

.refund-ticket__amount {
  grid-column: 2;
  text-align: center;
}

.refund-ticket__date {
  grid-column: 3;
  text-align: right;
  white-space: nowrap;
}

.refund-ticket__fee {
  grid-column: 1 / -1;
  text-align: center;
  white-space: nowrap;
}

.passenger-transactions-table {
  width: 100%;
}

.passenger-transactions-table /deep/ table {
  font-size: 12px;
}

.passenger-transactions-table /deep/ th,
.passenger-transactions-table /deep/ td {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.passenger-transactions-table /deep/ tbody td {
  height: 40px;
}

.passenger-transaction-checkbox-cell {
  padding-top: 8px !important;
}

.passenger-transaction-checkbox-cell /deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.passenger-transaction-phone-cell {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.passenger-transaction-type-cell {
  max-width: 140px;
}

.passenger-transaction-type-cell__content {
  display: flex;
  align-items: center;
  min-width: 0;
}

.passenger-transaction-type-cell__icon {
  flex-shrink: 0;
  margin-right: 4px;
}

.passenger-transaction-type-cell /deep/ .v-input {
  flex: 1 1 auto;
  min-width: 0;
}

.passenger-transaction-date-cell {
  min-width: 112px;
  white-space: nowrap;
}

.passenger-transaction-date-chip,
.passenger-transaction-type-chip {
  margin: 2px 0 0;
}

.passenger-trip-endpoint-heading {
  display: flex;
  align-items: center;
}

.passenger-trip-endpoint-pin {
  width: 16px;
  height: 22px;
  object-fit: contain;
  margin-right: 6px;
  flex-shrink: 0;
}

.txn-details {
  border-top: 1px solid #ccc;
}

.txn-details .info-card {
  margin-bottom: 8px;
}

.txn-split {
  display: flex;
  align-items: stretch;
}

.txn-split__cards {
  width: 50%;
  flex: 0 0 50%;
  min-width: 0;
  padding-right: 8px;
  overflow-y: auto;
}

.txn-split__cards .info-card {
  height: auto;
}

.txn-split__aside {
  width: 50%;
  flex: 0 0 50%;
  min-width: 0;
}

.txn-split__aside--map {
  overflow: hidden;
}

.txn-split__aside > .info-card {
  margin-bottom: 0;
}

.txn-details /deep/ .flex.sm8 {
  min-width: 0;
  word-break: break-word;
}

.txn-json-viewer-wrap {
  margin-top: 4px;
}

.txn-details-footer__checkbox {
  flex: 0 1 auto;
  margin-left: 8px;
}

.txn-json-viewer {
  font-size: 12px;
}

.txn-details /deep/ .txn-json-viewer .jv-code {
  padding: 12px;
}
</style>
